import * as Yup from "yup";
import * as yup from "yup";

const minText = (t: string, l: number) => {
  return `${t} must be ${l} caharacter or more`;
};
const requiredText = (t: string) => {
  return `${t} is required`;
};

export const contactValidationSchema = Yup.object({
  Name: Yup.string()
    .trim()
    .min(2, minText("Name", 2))
    .required(requiredText("Name")),
  EmailID: Yup.string()
    .trim()
    .email("Enter Valid email address")
    .required(requiredText("Email")),

  PhoneNo: Yup.string().required(requiredText("Phone Number")),
  Location: Yup.string()
    .trim()
    .min(2, minText("Location", 2))
    .required(requiredText("Location")),
  message: Yup.string(),
});

export const GetLatestPriceFormValidationSchema = Yup.object({
  Name: Yup.string()
    .trim()
    .min(2, minText("Name", 2))
    .required(requiredText("Name")),
  EmailID: Yup.string()
    .trim()
    .email("Enter Valid email address")
    .required(requiredText("Email")),

  PhoneNo: Yup.string().required(requiredText("Phone Number")),
  message: Yup.string(),
});

export const reviewSchema = Yup.object({
  Name: Yup.string()
    .trim()
    .min(2, minText("Name", 2))
    .required(requiredText("Name")),
  EmailID: Yup.string()
    .trim()
    .email("Enter valid email address")
    .required(requiredText("Email")),

  message: Yup.string(),
});


export const GetQuoteFormValidation = yup.object({
    Name: yup.string().required(requiredText("Name")),
    Message: yup.string().required(requiredText("Message")),
    PhoneNo: yup.string().required(requiredText("Phone Number")),
    EmailID: yup
      .string()
      .email("Email is not valid")
      .required(requiredText("Email")),
  });